import { useState } from "react";
import { Button, Spinner, Tab, TabList, Title3 } from "@fluentui/react-components";
import { Link } from "react-router-dom";
import { useMe, useTickets } from "../../api/hooks";
import { TicketTable, isClosed } from "../../components/TicketTable";

type TabKey = "open" | "closed";

export function MyTicketsPage() {
  const me = useMe();
  const isAdmin = me.data?.user.role === "Admin";
  const isAgentLike = me.data?.user.role === "Admin" || me.data?.user.role === "Agent";
  const [tab, setTab] = useState<TabKey>("open");

  // Fetch everything sorted by ticket number ascending. Up to 500 per call (backend max).
  // Then bucket client-side into Open / Closed.
  const q = useTickets({ sort: "number_asc", pageSize: 500 });

  const all = q.data?.items ?? [];
  const openItems = all.filter((t) => !isClosed(t.status));
  const closedItems = all.filter((t) => isClosed(t.status));
  const items = tab === "open" ? openItems : closedItems;

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
        <Title3>{isAdmin ? "All tickets" : "My tickets"}</Title3>
        <Link to="/new"><Button appearance="primary">New ticket</Button></Link>
      </div>

      <TabList selectedValue={tab} onTabSelect={(_, d) => setTab(d.value as TabKey)}>
        <Tab value="open">Open ({openItems.length})</Tab>
        <Tab value="closed">Closed ({closedItems.length})</Tab>
      </TabList>

      <div style={{ marginTop: 16 }}>
        {q.isLoading ? <Spinner /> : (
          <>
            <TicketTable tickets={items} showRequester={isAdmin} editable={isAgentLike} />
            {q.data && q.data.total > all.length && (
              <p style={{ marginTop: 12, color: "#605E5C", fontSize: 12 }}>
                Showing {all.length} of {q.data.total} tickets.
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
